import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';


@Injectable({ providedIn: 'root'})
export class ProtocolEndpoint extends EndpointFactory {

  private readonly _protocolsUrl: string = '/api/protocol';
  private readonly _protocolSubmissionRulesUrl: string = '/api/protocol/submissionrules';

  get protocolsUrl() { return this.configurations.baseUrl + this._protocolsUrl; }
  get protocolSumissionRulesUrl() { return this.configurations.baseUrl + this._protocolSubmissionRulesUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getProtocolByIdEndpoint<T>(protocolId: number): Observable<T> {
    const endpointUrl = protocolId ? `${this.protocolsUrl}/${protocolId}` : this.protocolsUrl;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  getFullProtocolByIdEndpoint<T>(protocolId: number): Observable<T> {
    const endpointUrl = protocolId ? `${this.protocolsUrl}/${protocolId}/full` : this.protocolsUrl;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  getProtocolSubmissionRulesEndpoint<T>(protocolId: number): Observable<T> {
    const endpointUrl = protocolId ? `${this.protocolSumissionRulesUrl}/${protocolId}` : this.protocolSumissionRulesUrl;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  getProtocolsEndpoint<T>(): Observable<T> {
    const endpointUrl = `${this.protocolsUrl}/all/default`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }
}
